import { Spinner } from '@hbo/ui-servicing-react-components';
import useAuth from 'hooks/useAuth';
import { Navigate } from 'react-router';
import { RoutePath } from 'types/global';

interface ProtectedRouteProps {
  element: React.ReactNode | React.ReactNode[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { isAuthenticating, isAuthenticated } = useAuth();

  if (isAuthenticating) {
    return <Spinner isBranded isFullscreen />;
  }

  if (isAuthenticated) {
    return <>{element}</>;
  }

  return <Navigate to={RoutePath.LoggedOut} />;
};

export default ProtectedRoute;
